var _Circle, _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#37CC33"
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.667 8.08A4.682 4.682 0 0 0 8 3.412V1.667L5.68 4.013 8 6.333V4.586a3.482 3.482 0 0 1 3.493 3.493c0 .6-.136 1.146-.41 1.638l.847.846c.464-.71.737-1.583.737-2.484ZM8 9.825v1.745A3.482 3.482 0 0 1 4.507 8.08c0-.601.136-1.147.409-1.638l-.846-.846a4.574 4.574 0 0 0-.737 2.484A4.682 4.682 0 0 0 8 12.745v1.747l2.319-2.347-2.32-2.32Z",
    fill: "white"
  })));
};
export default SvgRefresh;